import { memo } from "react";

import { useCart } from "@shopify/hydrogen-react";
import arePropsEqual from "react-fast-compare";

import { useAnalyticsEffect } from "@react/hooks/useAnalyticsEffect";
import { useCartAnalytics } from "@react/hooks/useCartAnalytics";
import { useSectionSettings } from "@sections/Root/SectionSettingsContext";
import {
  type CartSectionSettings,
  type CartUpsellProductMetadata,
} from "@tablescape/state";

type Props = {
  dataDrivenUpsells: boolean;
  upsellMetadata: CartUpsellProductMetadata[] | undefined;
};

const CartUpsellsAnalyticsBase = ({
  dataDrivenUpsells,
  upsellMetadata,
}: Props) => {
  const {
    meta: { customer },
  } = useSectionSettings<CartSectionSettings>();

  const { id: cartId, lines: cartLines } = useCart();

  const { reportUpsellsViewedEvent } = useCartAnalytics();

  useAnalyticsEffect(() => {
    if (!cartId || !cartLines || !customer || !upsellMetadata) {
      return;
    }

    reportUpsellsViewedEvent(
      {
        customer,
        dataDrivenUpsells,
        id: cartId,
        lines: cartLines,
      },
      upsellMetadata
    );
  }, [upsellMetadata]);

  return null;
};

export const CartUpsellsAnalytics = memo(
  CartUpsellsAnalyticsBase,
  arePropsEqual
);
